/** @format */
import { ButtonIconProps } from '@mpb-com/feather/components/atoms/icon';

export enum NavigationButtonDirection {
    UP = 'up',
    DOWN = 'down',
    LEFT = 'left',
    RIGHT = 'right',
}

export type NavigationButtonProps = ButtonIconProps & {
    /**
     * @default UP
     */
    direction: NavigationButtonDirection;
};

export type StyledNavigationButtonProps = Pick<
    NavigationButtonProps,
    'direction'
>;
